module.exports = __webpack_public_path__ + "static/media/MoonIcon.1402db3d.svg";